module.exports = __webpack_public_path__ + "../resources/img/ic_user_account.dd899587.svg";